var React = require('react');

function Trash2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.857143 12.4442C0.857143 13.2998 1.62857 13.9998 2.57143 13.9998H9.42857C10.3714 13.9998 11.1429 13.2998 11.1429 12.4442V3.11087H0.857143V12.4442ZM12 0.777534H9L8.14286 -0.000244141H3.85714L3 0.777534H0V2.33309H12V0.777534Z","fill":"#FCB34E"}));
}

Trash2.defaultProps = {"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none"};

module.exports = Trash2;

Trash2.default = Trash2;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/trash-2.svg
// module id = 262
// module chunks = 0